import React from 'react'

function intro() {
  return (
    <div class="instructions">
      
      <img src="images/VerticalPNG_HiRes.png" alt="logo" class="ne-logo"  />
      <div>
        <h2>Welcome to New Eyes' Application Portal!</h2>
        <ul>
          <li>To MAKE an application, go to the VOUCHERS tab above and select the blue tab (top right) of that page.</li>
          <li>There is a <strong>NON-REFUNDABLE</strong> $15 application fee for each application.
            Payment may be made with all major credit/debit cards or pre-paid credit cards.</li>
        </ul>
        <h2>
          ** New Eyes Order Site is now live **
     
        </h2>
        <ul>
          <li>
            In response to requests for upgrades such as progressives, blue light, transitions or tints, we have an <b>order site with low-cost out-of-pocket options</b>
            that individuals may also consider.            
          </li>
          <li>Please note New Eyes cannot pay for upgrades.</li>
          <li>Individuals who have paid the application fee will still be able to receive single-vision or lined bi-focal
            polycarbonate prescription glasses at no additional cost.</li>
        </ul>
        <p>*PLEASE READ THE INSTRUCTIONS ON OUR <a target="_blank" href="https://shop.neweyesglasses.org/pages/voucher-discount-lookup">ORDER SITE</a>
          &nbsp;TO <strong>CONVERT THE E-VOUCHER TO A COUPON CODE. Click&nbsp;
            <a target="_blank" href="https://new-eyes.org/new-ordering">here</a> for information about our eyeglasses
            ordering site.</strong></p>
        <p>Please email <a href="mailto:info@new-eyes.org">info@new-eyes.org</a>  with any questions about an application.</p>
        <p>Please email our dispensers at <a href="mailto:help@neweyesglasses.org">help@neweyesglasses.org</a>  with ordering or dispensing questions.</p>
      </div>
    </div>
  )
}

export default intro